// A phone camera photo is 2–10 MB; a report only needs to show what is broken. Before
// upload it is scaled down to at most MAX_SIDE pixels on its long side, as JPEG. A GIF
// (may be animated), a small file the server accepts, or one the browser can't decode
// goes as it is: the server still accepts up to 10 MB. Another type (HEIC from the Files
// app) is always converted; if that fails it is refused here with the server's own
// error, rather than uploaded only to be refused.

export const MAX_SIDE = 1600;
const QUALITY = 0.8;
const SMALL = 500 * 1024;
const SERVER_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

export function scaledSize(width, height, max = MAX_SIDE) {
  const scale = Math.min(1, max / Math.max(width, height));
  return { width: Math.round(width * scale), height: Math.round(height * scale) };
}

export async function shrinkPhoto(file) {
  if (!file || file.type === 'image/gif') return file;
  const accepted = SERVER_TYPES.includes(file.type);
  if (accepted && file.size <= SMALL) return file;
  try {
    // Modern browsers apply the EXIF orientation to naturalWidth/Height and drawImage
    const img = await decode(file);
    const { width, height } = scaledSize(img.naturalWidth, img.naturalHeight);
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#fff'; // a transparent PNG would turn black as JPEG
    ctx.fillRect(0, 0, width, height);
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(img, 0, 0, width, height);
    const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', QUALITY));
    if (!blob) throw new Error('encode');
    if (accepted && blob.size >= file.size) return file;
    return new File([blob], `${file.name.replace(/\.[^.]*$/, '') || 'foto'}.jpg`, { type: 'image/jpeg' });
  } catch {
    if (accepted) return file;
    throw Object.assign(new Error('photo_type'), { code: 'photo_type' });
  }
}

function decode(file) {
  const url = URL.createObjectURL(file);
  const img = new Image();
  return new Promise((resolve, reject) => {
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('decode')); };
    img.src = url;
  });
}
